export default __webpack_public_path__ + "static/media/phone-preview-banner.3af8780c.svg";